

import mapValues from 'lodash/mapValues';
import ceil from 'lodash/ceil';
import orderBy from 'lodash/orderBy';
import reduce from 'lodash/reduce';

import { currencyCode } from 'Helpers/Geo/data';
import { combineProductRegions } from 'Features/PickAndMix/helpers/pick-and-mix-helper';


const canConvertPickAndMixToBundle = (pickAndMix, preselectedSlugs) => {
  const pnmProducts = pickAndMix?.products;
  const preselectedProducts = (pnmProducts || []).filter(p => preselectedSlugs.includes(p.slug));
  const tiers = pickAndMix?.tiers;
  const quantities = tiers?.map(tier => tier.quantity) || [];
  const preSelectedProductsLength = preselectedProducts?.length;
  const tierMatch = quantities.includes(preSelectedProductsLength);
  return tierMatch;
};

const convertPickAndMixToBundle = (pickAndMix, preselectedSlugs) => {
  const pnmProducts = pickAndMix?.products;
  const tiers = pickAndMix?.tiers;
  const preselectedProducts = (pnmProducts || []).filter(p => preselectedSlugs.includes(p.slug));
  const quantity = preselectedProducts.length;
  let fullPrice = 0;

  preselectedProducts.forEach((p) => {
    fullPrice += p.price[currencyCode];
    p.display = true; // eslint-disable-line no-param-reassign
  });

  if (!quantity) {
    return [];
  }

  tiers.forEach((t) => {
    t.baseQuantity = t.quantity; // eslint-disable-line no-param-reassign
    t.basePrice = { ...t.price }; // eslint-disable-line no-param-reassign
  });

  const highestActiveTier = orderBy(tiers, 'quantity', 'desc').find(t => quantity >= t.quantity);

  if (!highestActiveTier) {
    return [];
  }

  const adjustedTier = {
    ...highestActiveTier,
    quantity,
    price: mapValues(
      highestActiveTier.basePrice,
      v => ceil((v / highestActiveTier.baseQuantity) * quantity),
    ),
  };

  const platforms = preselectedProducts.map(pp => pp.platforms);
  let validPlatforms = {};

  if (platforms && platforms.length > 0) {
    const initialObj = { windows: true, mac: true, linux: true };
    const reducedResult = reduce(platforms, (acc, obj) =>
      mapValues(acc, (value, key) => value && obj[key]), initialObj);

    validPlatforms = mapValues(reducedResult, Boolean);
  }

  const { regionsExcluded, regionsIncluded } = combineProductRegions(preselectedProducts);
  return {
    name: pickAndMix.name,
    type: 'bundle',
    drm: pickAndMix.drm,
    cover: pickAndMix.cover_image,
    template_type: 'standard',
    tiered: false,
    regions_excluded: regionsExcluded,
    regions_included: regionsIncluded,
    seo: {
      desc: pickAndMix.description,
    },
    price: adjustedTier.price,
    fullPrice: { [currencyCode]: fullPrice },
    desc: pickAndMix.about,
    platforms: validPlatforms,
    currentPrice: adjustedTier.price,
    img: [],
    bundles: [{
      displayTotal: preselectedProducts.length,
      downloadTotal: 0,
      filesTotal: 0,
      fullPrice: { [currencyCode]: fullPrice },
      games: preselectedProducts,
      incrementalFullPrice: fullPrice,
      price: adjustedTier.price,
    }],
  };
};

export { canConvertPickAndMixToBundle, convertPickAndMixToBundle };
